import React, { useRef } from 'react';
import './SwipeToDelete.scss';

export const SwipeToDelete = ({ onDelete = () => { }, id = null, children }) => {
    return (
        <div className='wrapper'>
            {
                <Item>
                    <div className="wrap-child">
                        {children}
                    </div>
                    <button className='swipe-delete-btn' onClick={() => onDelete(id, 'swipe')}>ลบ</button>
                </Item>
            }
        </div >
    );
}
export default SwipeToDelete;

const Item = ({ children }) => {
    const ref = useRef();
    let downX;
    let downY;
    const onPointerMove = (e) => {
        const newX = e.clientX;
        const newY = e.clientY;

        if ((newX - downX) < -10 && (newY - downY) < 10) {
            ref.current.style.transform = 'translate(-105px)';
        } else {
            ref.current.style.transform = 'translate(0px)'
        };
    };
    const onPointerDown = (e) => {
        downX = e.clientX;
        downY = e.clientY;
        ref.current.addEventListener('pointermove', onPointerMove);
    };

    const onPointerUp = () =>
        ref.current.removeEventListener("pointermove", onPointerMove);

    return (
        <div className='item-wrapper' onPointerDown={onPointerDown} onPointerUp={onPointerUp} ref={ref}>
            {children}
        </div>
    );
};